import {
  FilterContainer,
  FilterRow,
  InlineRadioButton,
  InlineReactSelect,
  InlineTextField,
  PrimaryButton,
  SecondaryButton,
} from "@graffer-inc/console-design-kit";
import React from "react";
import { SearchQueryProps } from "../../../../application/service/smart-apply/users/users-service";
import { Group } from "@graffer-inc/smart-apply/dist/application/domain/groups/group";

type UsersSearchContainerProps = {
  groups: Array<Group>;
  searchQuery: SearchQueryProps;
  setSearchQuery: (searchQuery: SearchQueryProps) => void;
  searchUsers: () => void;
};

interface selectOption {
  value: string;
  label: string;
}

export const UsersSearchContainer: React.FC<UsersSearchContainerProps> = ({
  groups,
  setSearchQuery,
  searchUsers,
}) => {
  const [q, setQ] = React.useState<string>("");
  const [groupId, setGroupId] = React.useState<selectOption | null>(null);
  const [disabled, setDisabled] = React.useState<string>("");
  const [authMethod, setAuthMethod] = React.useState<selectOption | null>(null);

  const doReset = () => {
    setQ("");
    setGroupId(null);
    setDisabled("");
    setAuthMethod(null);
    setSearchQuery({});
    searchUsers();
  };

  React.useEffect(() => {
    const groupIdValue = groupId ? groupId.value : undefined;
    const authMethodValue = authMethod ? authMethod.value : undefined;

    setSearchQuery({
      q,
      groupId: groupIdValue,
      disabled,
      authMethod: authMethodValue,
    });
  }, [q, groupId, disabled, authMethod, setSearchQuery]);

  return (
    <FilterContainer
      buttons={[
        <SecondaryButton key="resetButton" onClick={doReset} text="リセット" />,
        <PrimaryButton key="searchButton" onClick={searchUsers} text="検索" />,
      ]}
    >
      <FilterRow fullWidth>
        <InlineTextField
          label="アカウント"
          onChange={(e) => setQ(e.target.value)}
          placeholder="アカウント名、氏名で検索"
          value={q}
        />
      </FilterRow>
      <FilterRow>
        <InlineReactSelect
          label="グループ"
          onChange={(v: any) => setGroupId(v)}
          options={groups.map((group) => ({
            label: group.name,
            value: group.id!,
          }))}
          value={groupId}
        />
        <InlineReactSelect
          label="認証方式"
          onChange={(v: any) => setAuthMethod(v)}
          options={[
            {
              label: "パスワード",
              value: "password",
            },
            {
              label: "SAML",
              value: "saml",
            },
          ]}
          value={authMethod}
        />
        <InlineRadioButton
          label="ステータス"
          onChange={(e) => setDisabled(e.target.value)}
          options={[
            {
              name: "有効",
              value: "false",
            },
            {
              name: "無効",
              value: "true",
            },
          ]}
          value={disabled}
        />
      </FilterRow>
    </FilterContainer>
  );
};
